import React from "react";
import { useSelector } from "react-redux";
import { getUserById } from "../../store/selectors/users";
import { IUser } from "../../models/Users";
import { ProfileContactsSection } from "./ProfileContactsSection";
import { ProfileAboutSection } from "./ProfileAboutSection";
import { SecurityProfileSection } from "./SecurityProfileSection";
import { ProfileSideBarWrapper } from "../ProfileSideBar/styles";

export const ProfileUserSideBar = () => {
  const userProfile = useSelector(getUserById);

  return (
    <ProfileSideBarWrapper>
      <ProfileAboutSection profile={userProfile as IUser} />
      <ProfileContactsSection profile={userProfile as IUser} />
      <SecurityProfileSection />
    </ProfileSideBarWrapper>
  );
};
